export default {
  state: {
    notificationsList: [],
    unreadNotificationsList: [],
    requestsList: [],
    requestsListTotal: 0
  },
  mutations: {
    setNotificationsList: (state, { list }) => {
      state.notificationsList = list
    },
    setUnreadNotificationsList: (state, { list }) => {
      state.unreadNotificationsList = list
    },
    setRequestsList: (state, { list, total }) => {
      state.requestsList = list
      state.requestsListTotal = total
    }
  },
  actions: {}
}
